/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import {
    submitPlayerProfilePhotoCrop,
    submitPlayerProfileBannerCrop,
    removePlayerProfilePhoto,
    removePlayerBannerPhoto,
} from '../api/uploadApi';
import {
    playerMeta,
    playerProfile,
    saveProfile,
    availableRegions,
    playerStats,
    playerStudentInfo,
    savePlayerStudentInfo,
    playerPtsRankings,
    getProfileLocalizedRankings,
    getProfileViews,
    getPlayerVolumetricStats,
    getProfileActivityOverview,
    getPlayerPerformanceStats,
    getPlayerPerformanceStatsOverview,
} from '../api';

import { PROFILE_TAB_CLEAR_ALL_DATA, PROFILE_TAB_HAS_CHANGED_PROFILES } from './actionTypes/profile-tab-action-types';
import {
    PROFILE_GET_PERFORMANCE_STATS,
    PROFILE_GET_PERFORMANCE_STATS_SUCCESS,
    PROFILE_GET_PERFORMANCE_STATS_FAILURE,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS,
    PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE,
    PROFILE_GET_PTS_PLAYER_RANKING_REQUEST,
    PROFILE_GET_PTS_PLAYER_RANKING_SUCCESS,
    PROFILE_GET_PTS_PLAYER_RANKING_FAILURE,
    PROFILE_SET_PLAYER_ID,
} from './actionTypes/profile-action-types';
import { showErrorPopup } from './notification-actions';
import { gameTypes } from '../utils/constants';

export function setPlayerId(playerId, calledInProfile) {
    return (dispatch, getState) => {
        const { profile, profileTabData, auth } = getState();
        const hasProfileIdChanged = profile.playerId && profile.playerId !== playerId;

        if (profile.playerId !== playerId) {
            dispatch({
                type: 'SPLASH_SHOW_LOADING',
                title: 'Loading',
                description: 'Please wait while we\'re loading the requested profile data',
            });

            dispatch({ type: PROFILE_TAB_CLEAR_ALL_DATA });
        }

        dispatch({ type: PROFILE_SET_PLAYER_ID, playerId });
        dispatch(getPlayerProfileData());

        if (hasProfileIdChanged && calledInProfile && !profileTabData.hasChangedProfiles) {
            dispatch({ type: PROFILE_TAB_HAS_CHANGED_PROFILES, payload: true });
        }

        if (auth?.user && calledInProfile) {
            dispatch(getPlayerProfileLocalizedRankings(playerId));
            dispatch(getPlayerProfileVolumetricStatsOverview(playerId));
        }
    };
}

export function getPlayerProfile() {
    return (dispatch, getState, { mainApi }) => {
        const { playerId } = getState().profile;

        dispatch({ type: 'PROFILE:FETCH_REQUEST' });
        return playerProfile(mainApi, playerId)
            .then((result) => {
                if (getState().profile?.playerId !== playerId) {
                    return;
                }
                const { data } = result;

                if (data.error) {
                    dispatch({ type: 'PROFILE:FETCH_FAILURE', data });
                } else {
                    dispatch({ type: 'PROFILE:FETCH_SUCCESS', data });
                }
            })
            .catch((error) => {
                if (getState().profile?.playerId !== playerId) {
                    return;
                }
                const errorData = {
                    message: error?.response?.data,
                    statusCode: error?.response?.status,
                };
                dispatch({ type: 'PROFILE:FETCH_FAILURE', error: errorData });
            });
    };
}

export function getPlayerStudentInfo(playerIdPassed) {
    return (dispatch, getState, { mainApi }) => {
        const { playerId } = getState().profile;
        const playerIdCheck = playerId || playerIdPassed;

        dispatch({ type: 'PROFILE:FETCH_STUDENT_REQUEST' });
        return playerStudentInfo(mainApi, playerIdCheck)
            .then((res) => {
                const { data } = res;
                if (res.status > 400) {
                    throw new Error(`Unable to fetch player student info.`);
                } else {
                    dispatch({ type: 'PROFILE:FETCH_STUDENT_SUCCESS', data });
                }
            })
            .catch((error) => {
                dispatch({ type: 'PROFILE:FETCH_STUDENT_FAILURE' });
            });
    };
}

export const updatePlayerStudentInfo = profileValues => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'PROFILE:SAVE_STUDENT_REQUEST' });
    try {
        await savePlayerStudentInfo(mainApi, profileValues);
        dispatch({ type: 'PROFILE:SAVE_STUDENT_SUCCESS' });
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving profile',
            error,
        }));
        dispatch({ type: 'PROFILE:SAVE_STUDENT_FAILURE' });
    }
};

export function updateStatsParams(params) {
    return (dispatch, getState) => {
        const statsState = {
            ...(getState().profile.statsState),
            ...(params),
        };
        dispatch({
            type: 'PROFILE:UPDATE_STATS_PARAMS',
            data: {
                params: statsState,
            },
        });
    };
}

export function getPlayerStats(playerId) {
    return (dispatch, getState, { mainApi }) => {
        const { statsState } = getState().profile;
        dispatch({
            type: 'PROFILE:FETCH_PLAYER_STATS',
            data: {
                playerId,
            },
        });

        const { auth } = getState();

        if (auth.user === null) {
            dispatch({ type: 'PROFILE:FETCH_PLAYER_STATS_FAILURE' });
        } else {
            playerStats(mainApi, playerId, statsState)
                .then((result) => {
                    const { data } = result;
                    dispatch({
                        type: 'PROFILE:FETCH_PLAYER_STATS_SUCCESS',
                        data: {
                            stats: data,
                        },
                    });
                })
                .catch((error) => {
                    dispatch({ type: 'PROFILE:FETCH_PLAYER_STATS_FAILURE' });
                });
        }
    };
}

export function getPlayerProfileData() {
    return async (dispatch, getState, { mainApi }) => {
        const { auth, profile } = getState();
        const { playerId } = getState().profile;

        dispatch({ type: 'PROFILE:FETCH_REQUEST' });

        let playerProfileResult;
        let playerProfileData;
        try {
            playerProfileResult = await playerProfile(mainApi, playerId);
            // HUB-1100: drop stale response — matching request handles SPLASH_HIDE
            if (getState().profile?.playerId !== playerId) {
                return;
            }
            playerProfileData = playerProfileResult.data;

            if (playerProfileData.error) {
                dispatch({ type: 'PROFILE:FETCH_FAILURE', data: playerProfileData });
                dispatch({
                    type: 'SPLASH_HIDE',
                });
            } else {
                dispatch({ type: 'PROFILE:FETCH_SUCCESS', data: playerProfileData });
                dispatch({
                    type: 'SPLASH_HIDE',
                });

                const isOwnProfile = profile?.data && auth?.user?.id === playerProfileData.memberId;
                const isProCollegeClubOrganizerUser = auth.user?.isProCollegeClubOrganizer === true;
                const isCppEligibleCoachUser = auth.user?.isCollegeCoachCppEligible === true;
                if (isOwnProfile || isProCollegeClubOrganizerUser || isCppEligibleCoachUser) {
                    dispatch(getPlayerStudentInfo(playerId));
                }
            }
        } catch (error) {
            if (getState().profile?.playerId !== playerId) {
                return;
            }
            const errorData = {
                message: error?.response?.data,
                statusCode: error?.response?.status,
                isUnauthorized: error?.response?.status === 401,
            };
            dispatch({ type: 'PROFILE:FETCH_FAILURE', error: errorData });
            dispatch({
                type: 'SPLASH_HIDE',
            });
        }
    };
}

export const cropPlayerProfilePhoto = (playerId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:CROP_PROFILE_PHOTO',
        });
        const res = await submitPlayerProfilePhotoCrop(mainApi, playerId, values);
        dispatch({
            type: 'PROFILE:CROP_PROFILE_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image crop data.',
            error: err,
        }));
        throw err;
    }
};

export const cropPlayerBannerPhoto = (playerId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:CROP_BANNER_PHOTO',
        });
        const res = await submitPlayerProfileBannerCrop(mainApi, playerId, values);
        dispatch({
            type: 'PROFILE:CROP_BANNER_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};

export const removeProfilePhoto = playerId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:REMOVE_PROFILE_PHOTO',
        });
        const res = await removePlayerProfilePhoto(mainApi, playerId);
        dispatch({
            type: 'PROFILE:REMOVE_PROFILE_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing profile photo.',
            error: err,
        }));
        throw err;
    }
};

export const getAvailableRegions = (stateAbbr, countryCode) => async (dispatch, getState, { mainApi }) => {
    try {
        // Backend expects 3-letter region codes; PR maps to PUR (historical, not ISO 3166-1 alpha-3 'PRI'). Pending API migration to isoCountryCode2/isoCountryCode3.
        let countryAbbr = null;
        if (countryCode === 'US') {
            countryAbbr = 'USA';
        } else if (countryCode === 'PR') {
            countryAbbr = 'PUR';
        }
        const res = await availableRegions(mainApi, stateAbbr, countryAbbr);
        if (res.data) {
            return res.data;
        }
    } catch {
        return null;
    }
};

export const removeBannerPhoto = playerId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:REMOVE_BANNER_PHOTO',
        });
        const res = await removePlayerBannerPhoto(mainApi, playerId);
        dispatch({
            type: 'PROFILE:REMOVE_BANNER_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing profile photo.',
            error: err,
        }));
        throw err;
    }
};

export const savePlayerProfile = profileValues => async (dispatch, getState, { mainApi }) => {
    const { playerId } = getState().profile;
    dispatch({ type: 'PROFILE:SAVE_PROFILE' });
    try {
        await saveProfile(mainApi, playerId, profileValues);
        dispatch({ type: 'PROFILE:SAVE_PROFILE_SUCCESS' });
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving profile',
            error,
        }));
        dispatch({ type: 'PROFILE:SAVE_PROFILE_FAILURE' });
    }
};

export const getPlayerMetaData = playerId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:FETCH_METADATA_REQUEST',
        });

        const { auth } = getState();

        if (auth.user !== null) {
            const res = await playerMeta(mainApi, playerId);
            if (res.data.error) {
                dispatch({
                    type: 'PROFILE:FETCH_METADATA_FAILURE',
                    data: res.data,
                });
            } else {
                dispatch({
                    type: 'PROFILE:FETCH_METADATA_SUCCESS',
                    data: res.data,
                });
            }
        }
    } catch (error) {
        dispatch({
            type: 'PROFILE:FETCH_METADATA_FAILURE',
            data: error,
        });
    }
};

export const getPtsPlayerRankings = playerId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: PROFILE_GET_PTS_PLAYER_RANKING_REQUEST,
            playerId,
        });

        const { auth } = getState();

        if (auth.user === null) {
            dispatch({ type: PROFILE_GET_PTS_PLAYER_RANKING_FAILURE });
            return;
        }

        const res = await playerPtsRankings(mainApi, playerId);
        if (getState().profile?.ptsRankingsState?.playerId !== playerId) {
            return;
        }
        if (res.data.error) {
            dispatch({ type: PROFILE_GET_PTS_PLAYER_RANKING_FAILURE });
        } else {
            dispatch({
                type: PROFILE_GET_PTS_PLAYER_RANKING_SUCCESS,
                data: res.data,
            });
        }
    } catch {
        if (getState().profile?.ptsRankingsState?.playerId !== playerId) {
            return;
        }
        dispatch({ type: PROFILE_GET_PTS_PLAYER_RANKING_FAILURE });
    }
};

export const getPlayerProfileLocalizedRankings = playerId => async (dispatch, getState, { rankingsApi }) => {
    try {
        dispatch({ type: 'PROFILE:GET_LOCALIZED_RANKINGS' });

        const res = await getProfileLocalizedRankings(rankingsApi, playerId);

        if (res?.data?.data) {
            // Transform new API response structure to match expected format
            const rankings = res.data.data.rankings || [];

            const singlesRanking = rankings.find(r => r.ratingType === 'SinglesTennis');
            const doublesRanking = rankings.find(r => r.ratingType === 'DoublesTennis');

            const sortedSinglesUtrRankings = singlesRanking?.ranks?.sort((a, b) => a?.displayOrder - b?.displayOrder);
            const sortedDoublesUtrRankings = doublesRanking?.ranks?.sort((a, b) => a?.displayOrder - b?.displayOrder);

            const updatedRankings = {
                singlesUtrRankings: sortedSinglesUtrRankings || [],
                doublesUtrRankings: sortedDoublesUtrRankings || [],
            };

            dispatch({ type: 'PROFILE:GET_LOCALIZED_RANKINGS_SUCCESS', data: updatedRankings });
        }
    } catch {
        dispatch({ type: 'PROFILE:GET_LOCALIZED_RANKINGS_FAILURE' });
    }
};

export const getCollegeCoachProfileViews = (playerId, page, pageSize) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'PROFILE:GET_PROFILE_VIEWS',
        });
        const res = await getProfileViews(mainApi, playerId, page, pageSize);
        dispatch({
            type: 'PROFILE:GET_PROFILE_VIEWS_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch({
            type: 'PROFILE:GET_PROFILE_VIEWS_FAILURE',
            error: err,
        });
        throw err;
    }
};

export const getPlayerProfileVolumetricStats = playerId => async (dispatch, getState, { utrStatsApi }) => {
    if (playerId == null) { return; }
    const { volumetricStats } = getState().profile;
    if (volumetricStats.data != null) { return; }
    try {
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS' });
        const res = await getPlayerVolumetricStats(utrStatsApi, playerId);
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS_SUCCESS', data: { data: res?.data?.data ?? null } });
    } catch {
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS_FAILURE' });
    }
};

export const getPlayerProfileVolumetricStatsOverview = playerId => async (dispatch, getState, { utrStatsApi }) => {
    if (playerId == null) { return; }
    const { volumetricStatsOverview } = getState().profile;
    if (volumetricStatsOverview.data != null) { return; }
    try {
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW' });
        const res = await getProfileActivityOverview(utrStatsApi, playerId);
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW_SUCCESS', data: res?.data?.data ?? null });
    } catch {
        dispatch({ type: 'PROFILE:GET_VOLUMETRIC_STATS_OVERVIEW_FAILURE' });
    }
};

export const getPlayerProfilePerformanceStats = playerId => async (dispatch, getState, { performanceStatsApi }) => {
    if (playerId == null) { return; }
    const { performanceStats } = getState().profile;
    if (performanceStats.data != null) { return; }
    const isStaleResponse = () => getState().profile.playerId !== playerId;
    try {
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS });
        const res = await getPlayerPerformanceStats(performanceStatsApi, playerId, { matchtype: gameTypes.SINGLES });
        if (isStaleResponse()) { return; }
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_SUCCESS, data: res?.data?.data ?? null });
    } catch (err) {
        if (isStaleResponse()) { return; }
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_FAILURE, error: err });
    }
};

const NOT_FOUND_ERROR_TYPE = 'NotFoundError';

const isPerformanceStatsNotFound = body => !!body?.errors?.some(error => error?.type === NOT_FOUND_ERROR_TYPE);

export const getPlayerProfilePerformanceStatsOverview = playerId => async (dispatch, getState, { performanceStatsApi }) => {
    if (playerId == null) { return; }
    const { performanceStatsOverview } = getState().profile;
    // A player with no performance history resolves to `data: null`, so dedupe on
    // hasLoaded rather than data; a previous failure stays retryable.
    if (performanceStatsOverview.isLoading) { return; }
    if (performanceStatsOverview.hasLoaded && !performanceStatsOverview.error) { return; }
    const isStaleResponse = () => getState().profile.playerId !== playerId;
    try {
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_OVERVIEW });
        const res = await getPlayerPerformanceStatsOverview(performanceStatsApi, playerId);
        if (isStaleResponse()) { return; }
        if (res?.data?.success === false) {
            // The endpoint only covers singles, so it reports NotFound for players with
            // no singles performance stats. That is an empty result, not a failure.
            if (isPerformanceStatsNotFound(res.data)) {
                dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS, data: null });
                return;
            }
            dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE, error: res.data });
            return;
        }
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS, data: res?.data?.data ?? null });
    } catch (err) {
        if (isStaleResponse()) { return; }
        dispatch({ type: PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE, error: err });
    }
};
